import React from 'react'
import cx from 'classnames'

import Message from 'components/text/Message/Message'

import s from './FieldError.scss'


// TODO replace with <Text message={} type="error" />
const FieldError = ({ className, message }) => (
  <Message
    className={cx(s.error, className)}
    text={message}
    tag="div"
    aria-live="polite"
    role="region"
  />
)


export default FieldError
